import React from 'react';
import { convertUTCtoEST, convertUTCtoKST } from '../utils/timezone';
import './TimeDisplay.css';

interface TimeDisplayProps {
  utcTime: string; // ISO 8601 UTC 타임스탬프
  className?: string;
}

/**
 * TimeDisplay 컴포넌트
 *
 * 기본 표시: EST/EDT (24시간 형식)
 * 마우스 오버: KST 툴팁 표시
 *
 * @example
 * <TimeDisplay utcTime="2025-10-21T18:30:00Z" />
 * 표시: "2025-10-21 14:30:00"
 * 툴팁: "2025-10-22 03:30:00 KST"
 */
const TimeDisplay: React.FC<TimeDisplayProps> = ({ utcTime, className = '' }) => {
  // utcTime이 없거나 유효하지 않으면 기본값 표시
  if (!utcTime) {
    return <span className={className}>-</span>;
  }

  const estTime = convertUTCtoEST(utcTime);
  const kstTime = convertUTCtoKST(utcTime);

  // 변환 실패 시 기본값 표시
  if (estTime === 'Invalid Date' || kstTime === 'Invalid Date') {
    return <span className={className}>{utcTime}</span>;
  }

  return (
    <span className={`time-display ${className}`} data-tooltip={kstTime}>
      {estTime}
    </span>
  );
};

export default TimeDisplay;
